export enum ConversationMessageOriginEnum {
  Incoming = 1,
  Outgoing = 2,
}
